/* The merchant's Shopify product images stay separate from serving photography. */
(() => {
  'use strict';
  function init(root) {
    if (root.tfProductMenu) return;
    const preview = root.querySelector('[data-tf-menu-image]');
    const opener = root.querySelector('[data-tf-menu-open]');
    const dialog = root.querySelector('[data-tf-menu-dialog]');
    const full = root.querySelector('[data-tf-menu-full]');
    const canvas = root.querySelector('[data-tf-menu-canvas]');
    const zoom = root.querySelector('[data-tf-menu-zoom]');
    const close = root.querySelector('[data-tf-menu-close]');
    if (!preview || !opener || !dialog) return;
    const listeners = [];
    let focusBefore = null;
    let scrollLock = null;
    const listen = (target, type, handler) => { target.addEventListener(type, handler); listeners.push(() => target.removeEventListener(type, handler)); };
    const resetZoom = () => { canvas.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed', 'false'); zoom.textContent = 'Zoom in'; canvas.scrollTop = 0; canvas.scrollLeft = 0; };
    const unlock = () => {
      if (scrollLock && document.body.style.getPropertyValue('overflow') === 'hidden' && document.body.style.getPropertyPriority('overflow') === '') {
        if (scrollLock.value) document.body.style.setProperty('overflow', scrollLock.value, scrollLock.priority);
        else document.body.style.removeProperty('overflow');
      }
      scrollLock = null;
    };
    const restoreFocus = () => { if (focusBefore?.isConnected) focusBefore.focus({ preventScroll: true }); focusBefore = null; };
    const finishClose = () => { unlock(); resetZoom(); restoreFocus(); };
    const shut = () => { if (dialog.open) dialog.close(); finishClose(); };
    root.querySelectorAll('[data-tf-menu-thumbnail]').forEach(thumb => listen(thumb, 'click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      preview.srcset = thumb.dataset.srcset;
      preview.src = thumb.dataset.main;
      preview.alt = thumb.dataset.alt;
      preview.width = Number(thumb.dataset.width);
      preview.height = Number(thumb.dataset.height);
      preview.dataset.tfMenuOriginal = thumb.dataset.original;
      opener.href = thumb.href;
      root.querySelectorAll('[data-tf-menu-thumbnail]').forEach(item => { if (item === thumb) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current'); });
      const count = root.querySelector('[data-tf-menu-count]');
      count.textContent = `${thumb.dataset.index} / ${root.querySelectorAll('[data-tf-menu-thumbnail]').length}`;
    }));
    listen(opener, 'click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      focusBefore = document.activeElement;
      full.src = opener.href; full.alt = preview.alt;
      root.querySelector('[data-tf-menu-original-link]').href = preview.dataset.tfMenuOriginal || opener.href;
      root.querySelector('[data-tf-menu-caption]').textContent = preview.alt;
      resetZoom();
      dialog.showModal();
      scrollLock = { value: document.body.style.getPropertyValue('overflow'), priority: document.body.style.getPropertyPriority('overflow') };
      document.body.style.setProperty('overflow', 'hidden');
      close.focus({ preventScroll: true });
    });
    listen(close, 'click', shut);
    listen(dialog, 'cancel', event => { event.preventDefault(); shut(); });
    listen(dialog, 'close', finishClose);
    listen(dialog, 'click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) shut();
    });
    listen(zoom, 'click', () => {
      const enabled = !canvas.classList.contains('is-zoomed');
      canvas.style.setProperty('--tf-menu-zoom-width', `${Math.max(1000, Math.min(full.naturalWidth || 2000, 3000))}px`);
      canvas.classList.toggle('is-zoomed', enabled);
      zoom.setAttribute('aria-pressed', String(enabled)); zoom.textContent = enabled ? 'Fit to screen' : 'Zoom in';
      if (enabled) canvas.focus({ preventScroll: true });
    });
    root.tfProductMenu = { destroy() { shut(); listeners.forEach(remove => remove()); delete root.tfProductMenu; } };
  }
  const mount = scope => { if (scope.matches?.('[data-tf-menu-gallery]')) init(scope); scope.querySelectorAll('[data-tf-menu-gallery]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true }); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => { if (event.target.matches?.('[data-tf-menu-gallery]')) event.target.tfProductMenu?.destroy(); event.target.querySelectorAll('[data-tf-menu-gallery]').forEach(root => root.tfProductMenu?.destroy()); });
})();
